import { defineComponent as _defineComponent } from 'vue'
import { useImage } from '@/shared/composables/image'
import { useUserTicketsForEventQuery } from '@/features/tickets/api/queries'
import TicketLeft from '@/features/tickets/assets/TicketLeft.vue'
import AvatarPlaceholder from '@/features/tickets/assets/AvatarPlaceholder.vue'
import { computed, ref, watch } from 'vue'
import { mdiClose } from '@mdi/js'
import { IFrontdeskTicket, ITicketPurchased } from '@/features/tickets/types'
import TicketAssignmentInterface from '@/features/tickets/ui/TicketAssignmentInterface.vue'
import ChangeTierInterface from '@/features/tickets/ui/ChangeTierInterface.vue'
import RefundTicketInterface from '@/features/tickets/ui/RefundTicketInterface.vue'
import PurchaseReceipt from '@/features/tickets/ui/PurchaseReceipt.vue'
import { useUserQuery } from '@/enitites/user/api/queries'
import SelectedTicketAdmin from '@/features/tickets/ui/SelectedTicketAdmin.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminUserTicketsInterface',
  props: {
    eventId: null,
    initialTicket: null
  },
  setup(__props: any) {

const props = __props as {
  eventId: number
  initialTicket: IFrontdeskTicket
};



const { getImageById } = useImage()
const { data: userTickets, dataUpdatedAt } = useUserTicketsForEventQuery(
  props.eventId,
  props.initialTicket.assignedTo?.userId
)

const computedAssignedUserId = computed(() => {
  return props.initialTicket.assignedTo?.userId ? props.initialTicket.assignedTo.userId : undefined
})

const { data: userDetails, isLoading: isLoadingUserDetails } = useUserQuery(computedAssignedUserId)

const selectedTicket = ref<ITicketPurchased | undefined>(undefined)
const isShowAssignmentInterface = ref(false)
const isShowSuccessAssignmentMessage = ref(false)
const isShowChangeTierInterface = ref(false)
const isShowRefundInterface = ref(false)
const isShowReceiptInterface = ref(false)

watch(
  () => dataUpdatedAt.value,
  () => {
    if (userTickets.value && userTickets.value.length > 0) {
      const selectedTicketId = selectedTicket.value?.id || props.initialTicket.id || userTickets.value[0].id
      const foundTicket = userTickets.value.find((ticket) => ticket.id === selectedTicketId)
      if (foundTicket) {
        selectedTicket.value = foundTicket
      } else {
        selectedTicket.value = userTickets.value[0]
      }
    }
  },
  { immediate: true }
)

watch(
  () => selectedTicket.value,
  () => {
    isShowAssignmentInterface.value = false
    isShowChangeTierInterface.value = false
    isShowRefundInterface.value = false
    isShowReceiptInterface.value = false
  }
)

const getAgeByBirthdate = (birthdate: string): number => {
  const today = new Date()
  const birthDate = new Date(birthdate)
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDifference = today.getMonth() - birthDate.getMonth()
  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
    age -= 1
  }
  return age
}

return { __sfc: true,props, getImageById, userTickets, dataUpdatedAt, computedAssignedUserId, userDetails, isLoadingUserDetails, selectedTicket, isShowAssignmentInterface, isShowSuccessAssignmentMessage, isShowChangeTierInterface, isShowRefundInterface, isShowReceiptInterface, getAgeByBirthdate, TicketLeft, AvatarPlaceholder, mdiClose, TicketAssignmentInterface, ChangeTierInterface, RefundTicketInterface, PurchaseReceipt, SelectedTicketAdmin }
}

})